import { BuildYourCoverStateType } from '../../reducers/build-your-cover';
import { RootState } from '../../reducers';

const selectBuildYourCover = (state: RootState): BuildYourCoverStateType => state.buildYourCover;

export default selectBuildYourCover;
